<template>
    <div class="onboarding-step onboarding-step-welcome flex">
        <svg-vue class="welcome-image" icon="onboarding-welcome" />
        <div class="content">
            <svg-vue class="logo-onboarding" icon="logo-onboarding" />
            <p class="header">
                Hi {{ user.name }}!
            </p>
            <p class="text">
                You’re just a few clicks away from accessing our tools. Before we get there, we’d love to get to know you better. It’ll only take a moment!
            </p>
            <onboarding-controls
                :show-previous-btn="false"
                :show-skip-btn="true"
            >
                <template v-slot:button>
                    Let's get started
                </template>
                <template v-slot:skip-text>
                    I’ll do it later. Go to dashboard.
                </template>
            </onboarding-controls>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import OnboardingControls from './OnboardingControls.vue';

export default {
    components: {
        OnboardingControls,
    },

    computed: mapState([
        'user',
    ]),
};
</script>
